import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import {IonSlides, ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {CheckDeliveryRadiusModalComponent} from '../../../app/components/check-delivery-radius-modal/check-delivery-radius-modal.component';
import {DeliveryNotAvailableModalComponent} from '../../../app/components/delivery-not-available-modal/delivery-not-available-modal.component';
import {DeliveryNotAvailableAction} from '../../../app/enums/DeliveryNotAvailableAction';
import {MenuPage} from '../../../app/pages/menu/menu.page';
import {calculateGeoDistance, MapsUtils} from '../../utils/maps';
import {Api} from '../../../smoothr-web-app-core/api/api';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import Address from '../../../smoothr-web-app-core/models/Address';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {TimeUtils} from '../../../smoothr-web-app-core/utils/time-utils';
import {coverFlow, isVenueOpen, sleep, venueAcceptsOrders} from '../../../smoothr-web-app-core/utils/utils';

import Map = google.maps.Map;
import styledMap = google.maps.StyledMapType;
import MapOptions = google.maps.MapOptions;
import {OrderType} from 'src/smoothr-web-app-core/enums/OrderType';
import {NavigationService, NAVIGATIONURLS} from 'src/app/services/navigation.service';
import {BehaviorSubject} from 'rxjs';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ShowVenueInMapComponent} from 'src/app/components/show-venue-in-map/show-venue-in-map.component';
import {ScanQrModal} from 'src/app/components/scan-qr/scan-qr.component';
import {SelectTableModalComponent} from 'src/app/components/select-table-modal/select-table-modal.component';
import {ShowSocialLinksComponent} from 'src/app/components/show-social-links/show-social-links.component';
import {AlertInfoModalComponent} from 'src/app/components/alert-info-modal/alert-info-modal.component';
import {AppComponent} from 'src/app/app.component';

enum SelectedViewModelEnum {
	LIST,
	MYPLACE,
	MAP,
	FILTER
}
enum SelectedViewShopEnum {
	STORE,
	FRIDGE,
	PARTNERS
}

@Component({
	selector: 'app-map-venue',
	templateUrl: './map-venue.component.html',
	styleUrls: ['./map-venue.component.scss']
})
export class MapVenueComponent extends RepositoryDirective implements OnInit {
	@Input() showSearchInput = false;
	@Input() showVenueList = true;
	@Input() venueToFirstPositionShortId = '';
	@ViewChild('mapContainer', {static: true})
	mapElement: ElementRef;
	// @ViewChild(IonInput, { static: true })
	// inputField: IonInput;
	@ViewChild(IonSlides, {static: true})
	slides: IonSlides;
	map: Map;
	selectedViewModelEnum = SelectedViewModelEnum;
	public selectedView$ = new BehaviorSubject(SelectedViewModelEnum.MAP);
	public selectedViewPrev$ = new BehaviorSubject<SelectedViewModelEnum>(SelectedViewModelEnum.MAP);

	selectedViewShopEnum = SelectedViewShopEnum;
	public filterForm: FormGroup;
	userCoordinates: {lat: number; lng: number} | null = null;
	mapOptions: MapOptions = {
		maxZoom: 13,
		minZoom: 6,
		disableDefaultUI: true,
		clickableIcons: false,
		styles: [
			{
				featureType: 'administrative',
				elementType: 'geometry',
				stylers: [
					{
						color: '#a7a7a7'
					}
				]
			},
			{
				featureType: 'administrative',
				elementType: 'labels.text.fill',
				stylers: [
					{
						visibility: 'on'
					},
					{
						color: '#737373'
					}
				]
			},
			{
				featureType: 'landscape',
				elementType: 'geometry.fill',
				stylers: [
					{
						visibility: 'on'
					},
					{
						color: '#efefef'
					}
				]
			},
			{
				featureType: 'poi',
				elementType: 'geometry.fill',
				stylers: [
					{
						visibility: 'on'
					},
					{
						color: '#f5f5f5'
					}
				]
			},
			{
				featureType: 'poi',
				elementType: 'labels',
				stylers: [
					{
						visibility: 'on'
					}
				]
			},
			{
				featureType: 'poi',
				elementType: 'labels.text.fill',
				stylers: [
					{
						visibility: 'on'
					},
					{
						color: '#808080'
					}
				]
			},
			{
				featureType: 'poi',
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'on'
					},
					{
						color: '#cacaca'
					},
					{
						saturation: '-5'
					}
				]
			},
			{
				featureType: 'road',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#959595'
					}
				]
			},
			{
				featureType: 'road',
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ffffff'
					}
				]
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road.arterial',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ffffff'
					}
				]
			},
			{
				featureType: 'road.arterial',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#d6d6d6'
					}
				]
			},
			{
				featureType: 'road.local',
				elementType: 'geometry.fill',
				stylers: [
					{
						visibility: 'on'
					},
					{
						color: '#ffffff'
					},
					{
						weight: 1.8
					}
				]
			},
			{
				featureType: 'road.local',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#d7d7d7'
					}
				]
			},
			{
				featureType: 'transit',
				elementType: 'all',
				stylers: [
					{
						color: '#808080'
					},
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'water',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ebebeb'
					}
				]
			},
			{
				featureType: 'water',
				elementType: 'labels.text.fill',
				stylers: [
					{
						visibility: 'off'
					}
				]
			}
		],
		// [
		// 	{
		// 		featureType: 'poi.business',
		// 		stylers: [{visibility: 'on'}, {color: "#cacaca"}]
		// 	},
		// 	{elementType: 'geometry', stylers: [{saturation: -100}]}
		// ],
		backgroundColor: '#eeeeee'
	};
	style = [{elementType: 'geometry', stylers: [{saturation: -100}]}];
	clusterer: MarkerClusterer;
	loading = false;
	loadingAddress = false;
	predictions: Address[] = [];
	private _showPredictions = false;
	showHint = false;
	searchTerm: string;
	allVenues: Venue[] = [];
	localVenues: Venue[] = [];
	selectedVenueForDelivery: Venue;
	showMap = true;
	slidesOpts = {
		slidesPerView: 1,
		coverflowEffect: {
			rotate: 0,
			stretch: 15,
			depth: 10,
			modifier: 2
		},
		on: coverFlow
	};
	showInputForAddress = false;
	showListOfVenues = true;
	selectedVenue: Venue;
	MapsUtils = MapsUtils;
	@Input() selectFirstVenue: boolean = false;
	hideBlock = false;
	constructor(
		private snackbarCtrl: MatSnackBar,
		public repository: RepositoryService,
		private translate: TranslateService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalCtrl: ModalController,
		private navigationService: NavigationService,
		private fb: FormBuilder
	) {
		super(repository);
	}

	get relevantVenues(): Venue[] {
		return this.allVenues;
	}

	ngOnInit() {
		super.ngOnInit();
		this.map = new Map(this.mapElement.nativeElement, this.mapOptions);

		// tslint:disable-next-line:no-unused-expression
	}

	async resetMap() {
		if (this.allVenues.length === 0) {
			try {
				this.allVenues = (await Api.getAllVenues()).data
					.map(ven => {
						try {
							ven.openingHours = TimeUtils.sanitizeHours(ven.openingHours);
							ven.deliveryHours = TimeUtils.sanitizeHours(ven.deliveryHours);
						} catch (e) {
							console.error({
								message: 'Error while sanitizing hours ' + e,
								venue: ven.name + ' ' + ven.readableId,
								openingHours: ven.openingHours,
								deliveryHours: ven.deliveryHours
							});
						}
						return ven;
					})
					.filter(
						ven =>
							venueAcceptsOrders(ven, PreorderType.DELIVERY, false) ||
							venueAcceptsOrders(ven, PreorderType.TAKE_AWAY, false)
					);

				await this.setupMap();
			} catch (e) {}
		}
	}
	async addMyLocation() {
		try {
			this.loading = true;
			const myGeoLocation = await MapsUtils.getUserGeocode();
			// const testCoordinates = {lat: 50.126851, lng: 8.635183};
			this.clusterer = MapsUtils.addVenuesToMap(
				this.clusterer,
				null,
				this.relevantVenues,
				this.map,
				true,

				//TEST PLACE IN GERMANY
				{lat: myGeoLocation.lat, lan: myGeoLocation.lng},
				// {lat: testCoordinates.lat, lan: testCoordinates.lng},

				venue => {}
			);
			this.userCoordinates = myGeoLocation;
			// this.userCoordinates = testCoordinates;
			this.loading = false;
		} catch (e) {
			this.loading = false;
			this.userCoordinates = null;
			await AlertInfoModalComponent.show(
				this.modalCtrl,
				e.message,
				this.translate.instant('alert_info_dialog.position_not_found'),
				this.translate.instant('delete_subscription.no'),
				null
			);
			console.error(e);
			this.selectedView$.next(this.selectedViewPrev$.value);
		}
	}
	async setupMap(selectedVenue?: Venue, loadItem: boolean = false) {
		if (this.loading && !this.map) {
			return;
		}
		this.selectedVenue = selectedVenue;
		this.loading = true;
		this.cdr.detectChanges();
		try {
			this.clusterer = MapsUtils.addVenuesToMap(
				this.clusterer,
				selectedVenue,
				this.relevantVenues,
				this.map,
				false,
				{lan: 0, lat: 0},
				venue => this.setupMap(venue, !AppComponent.largeScreen$.getValue())
			);
			if (selectedVenue && selectedVenue.location && selectedVenue.location.coordinates) {
				const selectedIndex = this.relevantVenues.findIndex(ven => ven._id === selectedVenue._id);
				// wait until slides rendered
				await this.slides.length();
				await this.slides.slideTo(selectedIndex);
			}
		} catch (e) {
			// Rendering the map must never block the venue selection - without this the
			// component stays in `loading` state and selectVenue() silently returns early.
			console.error(e);
		} finally {
			this.loading = false;
			this.hideBlock = loadItem;
			this.cdr.detectChanges();
		}
	}

	async loadVenues(address: Address) {
		this.loading = true;
		this.cdr.detectChanges();
		this.localVenues = [];
		if (!this.customer.isAnonymous) {
			const address = {};
		}
		try {
			this.localVenues = await this.repository.getVenuesByAddress(address);
			this.searchTerm = MapsUtils.addressToString(address);
			if (this.localVenues.length === 0 && !this.selectedVenueForDelivery) {
				this.snackbarCtrl.open(
					this.translate.instant('map_page.no_venues_in_address', {
						title: this.searchTerm
					}),
					null,
					{
						duration: 2000
					}
				);
				this.loading = false;
				// await this.resetSearch();
				this.cdr.detectChanges();
				return;
			}
			if (this.selectedVenueForDelivery) {
				const deliveryVenues = this.localVenues.filter(ven => venueAcceptsOrders(ven, PreorderType.DELIVERY, false));
				const selectedDeliveryVenue = deliveryVenues.find(ven => ven._id === this.selectedVenueForDelivery._id);
				if (selectedDeliveryVenue) {
					await this.selectVenue(selectedDeliveryVenue, PreorderType.DELIVERY);
				} else {
					const choice = await DeliveryNotAvailableModalComponent.show(this.modalCtrl);
					switch (choice) {
						case DeliveryNotAvailableAction.DECLINE:
							this.localVenues = deliveryVenues;
							if (deliveryVenues.length === 0) {
								this.repository.address.emit(null);
							} else {
								this.showHint = true;
							}
							await this.setupMap(null);
							break;
						case DeliveryNotAvailableAction.TAKE_AWAY:
							await this.selectVenue(this.selectedVenueForDelivery, PreorderType.TAKE_AWAY);
							break;
					}
				}
				this.selectedVenueForDelivery = null;
				return;
			}
			this.selectedVenue = null;
			this.loading = false;
			await this.setupMap(this.selectedVenue);
		} catch (e) {
			console.error(e);
		}
		if (this.localVenues.length > 0 && this.selectFirstVenue) {
			// this.selectedVenue = this.localVenues[0];
		} else {
			this.selectedVenue = null;
		}
		this.loading = false;
		this.cdr.detectChanges();
	}

	async onSlideChange() {
		let index = await this.slides.getActiveIndex();
		if (index >= this.relevantVenues.length) {
			index = 0;
		}
		await this.setupMap(this.relevantVenues[index]);
	}
	selectVenueToDelivery(venue: Venue) {
		this.selectedVenueForDelivery = venue;
	}
	selectVenueFunc(venue: Venue) {
		this.selectedVenue = venue;
		this.setupMap(venue);
	}

	async selectVenue(venue: Venue, preorderType: PreorderType, attempt: number = 0, prevError: any = null) {
		if (
			preorderType === PreorderType.DELIVERY &&
			venue.distance > venue.deliveryRadius &&
			venue.deliveryByRadius &&
			!venue.isPostalDelivery
		) {
			this.snackbarCtrl.open(this.translate.instant('map_page.venue_does_not_delivery_to_address'), null, {
				duration: 2000
			});
			return;
		}
		if (attempt > 5) {
			this.loading = false;
			this.snackbarCtrl.open(prevError, null, {
				duration: 2000
			});
			return;
		}
		if (this.loading) {
			return;
		}
		this.cdr.detectChanges();
		this.loading = true;
		if (preorderType == PreorderType.INSIDE) {
			await this.repository.getVenue(venue._id);
			const table = await ScanQrModal.show(this.modalCtrl, venue);
			await sleep(200);
			if (!table) {
				this.snackbarCtrl.open(this.translate.instant('menu_page.no_table'), null, {
					duration: 2000
				});
				this.loading = false;
				return;
			}
			try {
				this.repository.createOrder(venue, this.address, OrderType.PREORDER, preorderType, null, true);
				sleep(200);
				this.order.tableNumber = table.number;
				this.order.table = table._id;
				this.repository.order.emit(this.order);
				await SelectTableModalComponent.show(this.modalCtrl, this.order);
				this.router.navigateByUrl(NAVIGATIONURLS.menu(), {
					replaceUrl: true
				});
				this.loading = false;
				return;
			} catch (e) {
				console.error(e);
				this.snackbarCtrl.open(this.translate.instant('menu_page.venue_panic_or_closed'), null, {
					duration: 2000
				});
				this.loading = false;

				return;
			}
		}
		if (preorderType === PreorderType.DELIVERY) {
			try {
				await this.repository.getVenue(venue._id);
				this.repository.createOrder(this.venue, this.address, OrderType.PREORDER, PreorderType.DELIVERY, null, true);
				this.router.navigateByUrl(NAVIGATIONURLS.menu(), {
					replaceUrl: true
				});

				this.loading = false;
				return;
			} catch (e) {
				this.loading = false;
				return;
			}
		}
		try {
			await this.repository.getVenue(venue._id);
			this.repository.createOrder(venue, this.address, OrderType.PREORDER, preorderType, null, true);
			this.router.navigateByUrl(NAVIGATIONURLS.menu(), {
				replaceUrl: true
			});
			// await MenuPage.navigate(this.router);
			this.loading = false;
			this.cdr.detectChanges();
		} catch (e) {
			// release the guard before retrying, otherwise the retry returns early on `loading`
			this.loading = false;
			await this.selectVenue(venue, preorderType, attempt + 1, e);
		}
	}

	async loadPlace(pred: Address) {
		if (this.loading) {
			return;
		}
		this.loading = false;
		this.cdr.detectChanges();
	}

	onAddress() {
		super.onAddress();
		// tslint:disable-next-line:no-unused-expression
		new Promise(async () => {
			await this.resetMap();
		});
	}

	setShowMap(value: boolean) {
		this.showMap = value;
		this.cdr.detectChanges();
	}
	async changesAddress(address: Address) {
		this.repository.address.emit(address);
		await this.onSlideChange();
	}
	async changeSelectedViewModel(value: SelectedViewModelEnum) {
		this.selectedViewPrev$.next(this.selectedView$.value);
		await sleep(150);
		this.selectedView$.next(value);
		if (value == SelectedViewModelEnum.MYPLACE) {
			await this.addMyLocation();
		}
		if (value == SelectedViewModelEnum.MAP) {
			await this.setupMap();
		}
		console.log();
	}
	clearVenue() {
		this.selectedVenue = null;
		this.cdr.detectChanges();
		this.loadVenues(this.address);
		this.cdr.detectChanges();
		this.hideBlock = false;
	}
	async addFilters(event: string[]) {
		if (this.selectedViewPrev$.value !== SelectedViewModelEnum.FILTER) {
			this.changeSelectedViewModel(this.selectedViewPrev$.value);
		}
		if (event.length > 0) {
			if (event.includes('isOpen')) {
				this.allVenues = this.allVenues.filter(it => isVenueOpen(it));
			}
			if (event.includes('fridge')) {
				this.allVenues = [];
				this.snackbarCtrl.open('Keine Kühlschränke im Moment...', null, {duration: 3000});
				//TODO type fridge
			}
			if (event.includes('store')) {
				await this.resetMap();
				//TODO type fridge
			}
		}
		console.log(this.selectedViewPrev$.value, this.selectedView$.value);
	}
	async showVenue(venue: Venue) {
		const result = await ShowVenueInMapComponent.show(this.modalCtrl, venue);
		if (result?.venue && result?.preorderType) {
			this.selectVenue(result.venue, result.preorderType);
		}
	}
	async showDialogToSelectSocialMedia(userCoordinates: {lat: number; lng: number}) {
		await ShowSocialLinksComponent.show(this.modalCtrl, userCoordinates);
	}

	async backToGetAdress() {
		this.navigationService.home({
			openGetAdressModal: true
		});
	}
}
